<template>
  <b-card>
    <div slot="header">
      <i :class="options.icon || 'fa fa-align-justify'"></i>

      <strong>
        {{ options.name || '' }}
      </strong>

      <small>
        {{ options.caption || '' }}
      </small>

      <div class="card-actions text-right">
        <div class="align-left label-description">Total:</div>
        <div class="align-left">
          <a :href="options.link.href || '#!'"
            :target="options.link.target || '_self'">

            <slot name="action"></slot>
          </a>
        </div>
      </div>
    </div>

    <b-list-group>
      <slot name="card"></slot>
    </b-list-group>

    <div slot="footer">
      <slot name="footer">
        <a :href="options.link.href || '#!'"
          :target="options.link.target || '_self'">

          <small class="btn pull-right">
            Visualizar tudo
          </small>
        </a>
      </slot>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'list-groups',

  props: {
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/ListGroups.vue